import React from 'react';
import {SEND_PROVIDERS} from '../../../constants';
import PinpointParameters from './PinpointParameters';
import MappParameters from './MappParameters';
import AwsParameters from './AwsParameters';
import SendProviderBox from './SendProviderBox';
import SendProviderParameters from './SendProviderParameters';
import {sendProvidersSchemas} from './sendProvidersSchema';

export const SendProviders = ({setFieldValue, intl, values}) => {
    return (
        <>
            <div className="row mb-0">
                <div className="col-12 mb-3">
                    <SendProviderBox provider={SEND_PROVIDERS.MAPP} values={values[SEND_PROVIDERS.MAPP]} setFieldValue={setFieldValue}>
                        <div className="btn-group">
                            <SendProviderParameters setFieldValue={setFieldValue}
                                values={values[SEND_PROVIDERS.MAPP]}
                                provider={SEND_PROVIDERS.MAPP}
                                validationSchema={sendProvidersSchemas[SEND_PROVIDERS.MAPP]}>
                                <MappParameters provider={SEND_PROVIDERS.MAPP} />
                            </SendProviderParameters>
                        </div>
                    </SendProviderBox>
                </div>
            </div>
            <div className="row mb-0">
                <div className="col-12 mb-3">
                    <SendProviderBox provider={SEND_PROVIDERS.PINPOINT} values={values[SEND_PROVIDERS.PINPOINT]} setFieldValue={setFieldValue}>
                        <div className="btn-group">
                            <SendProviderParameters setFieldValue={setFieldValue}
                                values={values[SEND_PROVIDERS.PINPOINT]}
                                provider={SEND_PROVIDERS.PINPOINT}
                                validationSchema={sendProvidersSchemas[SEND_PROVIDERS.PINPOINT]}>
                                <PinpointParameters provider={SEND_PROVIDERS.PINPOINT} />
                            </SendProviderParameters >
                        </div>
                    </SendProviderBox>
                </div>
            </div>
            <div className="row mb-0">
                <div className="col-12 mb-3">
                    <SendProviderBox provider={SEND_PROVIDERS.AWS} values={values[SEND_PROVIDERS.AWS]} setFieldValue={setFieldValue}>
                        <div className="btn-group">
                            <SendProviderParameters setFieldValue={setFieldValue}
                                values={values[SEND_PROVIDERS.AWS]}
                                provider={SEND_PROVIDERS.AWS}
                                validationSchema={sendProvidersSchemas[SEND_PROVIDERS.AWS]}>
                                <AwsParameters provider={SEND_PROVIDERS.AWS} />
                            </SendProviderParameters>
                        </div>
                    </SendProviderBox>
                </div>
            </div>
        </>
    );
};


export default SendProviders;
